/**
 * Dati base delle 29 associazioni + costanti di stile condivise tra
 * AssociazioniPage e AssociazioneDettaglioPage.
 */

export const TIPOLOGIE = [
  "Associazioni e Federazioni di Categoria",
  "Gruppi trasversali",
  "Associazioni Territoriali",
  "Associazioni Aderenti",
];

export const MERCATI = [
  "Ristorazione e Turismo",
  "Immobiliare",
  "Commercio",
  "Servizi e ICT",
  "Alimentare",
  "Professioni",
  "Sanità",
  "Mobilità",
];

const ASSOCIAZIONI_UNSORTED = [
  /* ── Federazioni e associazioni di categoria ── */
  {
    id: "abiconf",
    nome: "ABICONF Roma – Amministratori Beni Immobili",
    tipologia: "Associazioni e Federazioni di Categoria",
    mercato: "Immobiliare",
    url: "https://www.confcommercioroma.it/associazioni/abiconf-roma/",
    descrizione: "Rappresenta e tutela gli amministratori di beni immobili nel territorio romano.",
    logo: "/loghi-associazioni/abiconf.webp",
  },
  {
    id: "ali-roma",
    nome: "ALI Roma – Associazione Librai",
    tipologia: "Associazioni e Federazioni di Categoria",
    mercato: "Commercio",
    url: "https://www.confcommercioroma.it/associazioni/ali-roma/",
    descrizione: "Associazione che tutela e promuove i librai indipendenti di Roma.",
    logo: "/loghi-associazioni/ali.webp",
    darkLogo: true,
  },
  {
    id: "asfo",
    nome: "ASFO Sanità Lazio",
    tipologia: "Associazioni e Federazioni di Categoria",
    mercato: "Sanità",
    url: "https://www.confcommercioroma.it/associazioni/asfo-sanita-lazio/",
    descrizione: "Associazione delle strutture sanitarie private del Lazio aderenti a Confcommercio.",
    logo: "/loghi-associazioni/asfo.webp",
  },
  {
    id: "assintel",
    nome: "ASSINTEL Roma e Lazio",
    tipologia: "Associazioni e Federazioni di Categoria",
    mercato: "Servizi e ICT",
    url: "https://www.confcommercioroma.it/associazioni/assintel-roma-e-lazio/",
    descrizione: "Associazione nazionale delle imprese ICT, rappresenta il settore tecnologico e digitale.",
    logo: "/loghi-associazioni/assintel.webp",
  },
  {
    id: "professioni",
    nome: "Associazione Territoriale PROFESSIONI Confcommercio Roma",
    tipologia: "Associazioni e Federazioni di Categoria",
    mercato: "Professioni",
    url: "https://www.confcommercioroma.it/associazioni/confcommercio-professioni-roma/",
    descrizione: "Punto di riferimento per i professionisti associati a Confcommercio Roma.",
    logo: "/loghi-associazioni/professioni.png",
  },
  {
    id: "fida",
    nome: "F.I.D.A. – Federazione Italiana Dettaglio Alimentare",
    tipologia: "Associazioni e Federazioni di Categoria",
    mercato: "Alimentare",
    url: "https://www.confcommercioroma.it/associazioni/aprida/",
    descrizione: "Tutela il commercio al dettaglio alimentare: macellerie, pescherie, gastronomie e negozi di generi alimentari.",
    logo: "/loghi-associazioni/fida.png",
    darkLogo: true,
  },
  {
    id: "fima",
    nome: "F.I.M.A. Roma – Federazione Italiana Mercanti d'Arte",
    tipologia: "Associazioni e Federazioni di Categoria",
    mercato: "Commercio",
    url: "https://www.confcommercioroma.it/associazioni/fimaroma/",
    descrizione: "Rappresenta i mercanti d'arte e gli operatori del mercato dell'arte a Roma.",
    logo: "/loghi-associazioni/fima-nuovo.png",
  },
  {
    id: "fimaa",
    nome: "F.I.M.A.A. Roma – Federazione Italiana Mediatori Agenti d'Affari",
    tipologia: "Associazioni e Federazioni di Categoria",
    mercato: "Immobiliare",
    url: "https://www.confcommercioroma.it/associazioni/fimaa-roma/",
    descrizione: "Associazione degli agenti immobiliari e mediatori d'affari di Roma.",
    logo: "/loghi-associazioni/fimaa.webp",
  },
  {
    id: "fedagro",
    nome: "FEDAGRO Mercati Roma",
    tipologia: "Associazioni e Federazioni di Categoria",
    mercato: "Alimentare",
    url: "https://www.confcommercioroma.it/associazioni/fedagro-mercati-roma/",
    descrizione: "Rappresenta gli operatori dei mercati all'ingrosso e al dettaglio di prodotti alimentari.",
    logo: "/loghi-associazioni/fedagromercati-nuovo.png",
  },
  {
    id: "moda-italia",
    nome: "Federazione Moda Italia Roma",
    tipologia: "Associazioni e Federazioni di Categoria",
    mercato: "Commercio",
    url: "https://www.confcommercioroma.it/associazioni/federazione-moda-italia-roma/",
    descrizione: "Associazione di riferimento per le imprese della moda, abbigliamento e accessori.",
    logo: "/loghi-associazioni/moda-italia-nuovo4.png",
  },
  {
    id: "federpreziosi",
    nome: "FEDERPREZIOSI Roma",
    tipologia: "Associazioni e Federazioni di Categoria",
    mercato: "Commercio",
    url: "https://www.confcommercioroma.it/associazioni/federpreziosi-roma/",
    descrizione: "Tutela e rappresenta gli operatori del settore orafo, argentiero e dei preziosi.",
    logo: "/loghi-associazioni/federpreziosi.png",
    darkLogo: true,
  },
  {
    id: "federservizi",
    nome: "FEDERSERVIZI",
    tipologia: "Associazioni e Federazioni di Categoria",
    mercato: "Servizi e ICT",
    url: "https://www.confcommercioroma.it/associazioni/federservizi/",
    descrizione: "Federazione delle imprese di servizi alle aziende e ai consumatori.",
    logo: "/loghi-associazioni/federservizi-nuovo2.png",
    darkLogo: true,
  },
  {
    id: "apm",
    nome: "APM – Associazione Parcheggi e Servizi per la Mobilità Urbana",
    tipologia: "Associazioni e Federazioni di Categoria",
    mercato: "Mobilità",
    url: "https://www.confcommercioroma.it/associazioni/apm-associazione-parcheggi-e-servizi-per-la-mobilita-urbana/",
    descrizione: "Rappresenta e tutela le imprese che operano nel settore della gestione dei parcheggi, delle aree di sosta e dei servizi per la mobilità urbana.",
    logo: "/loghi-associazioni/apm.webp",
  },
  {
    id: "fipe",
    nome: "FIPE Roma – Federazione Italiana Pubblici Esercizi",
    tipologia: "Associazioni e Federazioni di Categoria",
    mercato: "Ristorazione e Turismo",
    url: "https://www.confcommercioroma.it/associazioni/fipe-confcommercio-roma/",
    descrizione: "Rappresenta bar, ristoranti, pizzerie, caffè e locali di pubblico esercizio.",
    logo: "/loghi-associazioni/fipe-nuovo-2.png",
  },
  {
    id: "fiva",
    nome: "FIVA – Federazione Italiana Venditori Ambulanti",
    tipologia: "Associazioni e Federazioni di Categoria",
    mercato: "Commercio",
    url: "https://www.confcommercioroma.it/associazioni/fiva-roma/",
    descrizione: "Tutela gli operatori del commercio su aree pubbliche, mercati rionali e fiere.",
    logo: "/loghi-associazioni/fiva.webp",
  },

  /* ── Associazioni aderenti ── */
  {
    id: "rinascita",
    nome: "Rinascita Imprese",
    tipologia: "Associazioni Aderenti",
    mercato: null,
    url: "https://www.confcommercioroma.it/chi-siamo/le-associazioni/associazioni-aderenti/rinascita-imprese/",
    descrizione: "Associazione a supporto delle imprese nel loro percorso di crescita e rilancio.",
    logo: "/loghi-associazioni/rinascita-imprese.webp",
  },
  {
    id: "confederazione-sport",
    nome: "Confederazione dello Sport",
    tipologia: "Associazioni Aderenti",
    mercato: null,
    url: "https://www.confcommercioroma.it/chi-siamo/le-associazioni/associazioni-aderenti/confederazione-dello-sport/",
    descrizione: "Rappresenta le imprese dello sport, delle palestre e degli impianti sportivi.",
    logo: "/loghi-associazioni/confederazione-sport.webp",
  },
  {
    id: "fiavet",
    nome: "FIAVET Lazio",
    tipologia: "Associazioni Aderenti",
    mercato: "Ristorazione e Turismo",
    url: "https://www.confcommercioroma.it/chi-siamo/le-associazioni/associazioni-aderenti/fiavet-lazio/",
    descrizione: "Federazione Italiana delle Associazioni di Viaggio e Turismo – sezione Lazio.",
    logo: "/loghi-associazioni/fiavet.webp",
  },
  {
    id: "federalberghi",
    nome: "FEDERALBERGHI Roma",
    tipologia: "Associazioni Aderenti",
    mercato: "Ristorazione e Turismo",
    url: "https://www.confcommercioroma.it/chi-siamo/le-associazioni/associazioni-aderenti/federalberghi-roma/",
    descrizione: "Associazione degli albergatori e delle strutture ricettive di Roma.",
    logo: "/loghi-associazioni/federalberghi.webp",
  },
  {
    id: "anec",
    nome: "ANEC Lazio",
    tipologia: "Associazioni Aderenti",
    mercato: null,
    url: "https://www.confcommercioroma.it/chi-siamo/le-associazioni/associazioni-aderenti/anec-lazio/",
    descrizione: "Associazione Nazionale Esercenti Cinema – delegazione Lazio.",
    logo: "/loghi-associazioni/anec.webp",
  },
  {
    id: "teatri-roma",
    nome: "Unione Teatri di Roma",
    tipologia: "Associazioni Aderenti",
    mercato: null,
    url: "https://www.confcommercioroma.it/chi-siamo/le-associazioni/associazioni-aderenti/unione-teatri-di-roma/",
    descrizione: "Rappresenta i teatri privati e le imprese dello spettacolo dal vivo a Roma.",
    logo: "/loghi-associazioni/utr.webp",
  },
  {
    id: "assopetroli",
    nome: "Assopetroli – Assoenergia",
    tipologia: "Associazioni Aderenti",
    mercato: null,
    url: "https://www.confcommercioroma.it/chi-siamo/le-associazioni/associazioni-aderenti/assopetroli-assoenergia/",
    descrizione: "Associazione delle imprese distributori di prodotti petroliferi ed energetici.",
    logo: "/loghi-associazioni/assopetroli.webp",
  },

  /* ── Gruppi trasversali ── */
  {
    id: "impresa-cultura",
    nome: "Coordinamento Impresa Cultura Confcommercio Roma",
    tipologia: "Gruppi trasversali",
    mercato: null,
    url: "https://www.confcommercioroma.it/chi-siamo/le-associazioni/gruppi-trasversali/coordinamento-impresa-cultura-confcommercio-roma/",
    descrizione: "Gruppo che valorizza le imprese culturali e creative nel sistema di Confcommercio Roma.",
    logo: "/loghi-associazioni/coordinamento-impresa-cultura.webp",
  },
  {
    id: "terziario-donna",
    nome: "Confcommercio Terziario Donna Roma",
    tipologia: "Gruppi trasversali",
    mercato: null,
    url: "https://www.confcommercioroma.it/chi-siamo/le-associazioni/gruppi-trasversali/terziario-donna-roma/",
    descrizione: "Gruppo dedicato all'imprenditoria femminile e alle pari opportunità nel terziario.",
    logo: "/loghi-associazioni/terziario-donna.png",
    darkLogo: true,
  },
  {
    id: "giovani-imprenditori",
    nome: "Gruppo Giovani Imprenditori Confcommercio Roma",
    tipologia: "Gruppi trasversali",
    mercato: null,
    url: "https://www.confcommercioroma.it/chi-siamo/le-associazioni/gruppi-trasversali/gruppo-giovani-imprenditori-roma/",
    descrizione: "Gruppo dedicato ai giovani imprenditori under 42 per networking, formazione e innovazione.",
    logo: "/loghi-associazioni/giovani-imprenditori-nuovo.png",
    darkLogo: true,
  },

  /* ── Associazioni territoriali ── */
  {
    id: "centro-storico",
    nome: "Confcommercio Roma Centro Storico – Municipio I",
    tipologia: "Associazioni Territoriali",
    mercato: null,
    url: "https://www.confcommercioroma.it/chi-siamo/le-associazioni/associazioni-territoriali/confcommercio-roma-centro-storico/",
    descrizione: "Punto di riferimento per le imprese del Centro Storico e del Municipio I di Roma.",
    logo: "/loghi-associazioni/centro-storico-nuovo.webp",
  },
  {
    id: "civitavecchia",
    nome: "Confcommercio Civitavecchia Litorale Nord",
    tipologia: "Associazioni Territoriali",
    mercato: null,
    url: "https://www.confcommercioroma.it/chi-siamo/le-associazioni/associazioni-territoriali/confcommercio-civitavecchia-litorale-nord/",
    descrizione: "Associazione territoriale per le imprese di Civitavecchia e del Litorale Nord.",
    logo: "/loghi-associazioni/civitavecchia.png",
    darkLogo: true,
  },
  {
    id: "litorale-sud",
    nome: "Ascom Confcommercio Roma Litorale Sud",
    tipologia: "Associazioni Territoriali",
    mercato: null,
    url: "https://www.confcommercioroma.it/chi-siamo/le-associazioni/associazioni-territoriali/ascom-confcommercio-roma-litorale-sud/",
    descrizione: "Associazione territoriale per le imprese del Litorale Sud di Roma.",
    logo: "/loghi-associazioni/litorale-sud.png",
    darkLogo: true,
  },
];

/* Elenco ordinato alfabeticamente per nome (usato da tutte le pagine) */
export const ASSOCIAZIONI = [...ASSOCIAZIONI_UNSORTED].sort((a, b) =>
  a.nome.localeCompare(b.nome, "it", { sensitivity: "base" })
);

/* ── Foto per mercato (per card senza logo) ─────────────────────── */
export const MERCATO_IMAGES = {
  "Ristorazione e Turismo": "https://images.pexels.com/photos/1872888/pexels-photo-1872888.jpeg?auto=compress&cs=tinysrgb&w=800",
  "Immobiliare": "https://images.pexels.com/photos/2079234/pexels-photo-2079234.jpeg?auto=compress&cs=tinysrgb&w=800",
  "Commercio": "https://images.pexels.com/photos/5498024/pexels-photo-5498024.jpeg?auto=compress&cs=tinysrgb&w=800",
  "Servizi e ICT": "https://images.pexels.com/photos/7689876/pexels-photo-7689876.jpeg?auto=compress&cs=tinysrgb&w=800",
  "Alimentare": "https://images.unsplash.com/photo-1767364084218-a18f3ea7e93f?w=800&q=80",
  "Professioni": "https://images.unsplash.com/photo-1758518727984-17b37f2f0562?w=800&q=80",
  "Sanità": "https://images.pexels.com/photos/7108396/pexels-photo-7108396.jpeg?auto=compress&cs=tinysrgb&w=800",
  "Mobilità": "https://images.unsplash.com/photo-1710760743800-b27ae6d05d05?w=800&q=80",
};
export const DEFAULT_IMAGE = "https://images.pexels.com/photos/6949392/pexels-photo-6949392.jpeg?auto=compress&cs=tinysrgb&w=800";

/* ── Descrizioni per tipologia ──────────────────────────────────── */
export const TIPOLOGIA_DESCRIZIONI = {
  "Associazioni e Federazioni di Categoria": "Le Associazioni e Federazioni di Categoria rappresentano l'ossatura specialistica del sistema di Confcommercio Roma: organizzazioni che presidiano con competenza e dedizione ciascun settore del terziario – dal commercio al turismo, dai servizi alle professioni – per offrire supporto mirato, normativa aggiornata, formazione di settore e advocacy qualificata.",
  "Associazioni Aderenti": "Le Associazioni Aderenti rappresentano l'anima operativa del nostro sistema: sono i punti di riferimento sul territorio per le imprese del commercio, del turismo, dei servizi e delle professioni che scelgono di associarsi a Confcommercio Roma.",
  "Gruppi trasversali": "In Confcommercio Roma nascono i Gruppi Trasversali, spazi vivi e inclusivi dedicati a imprenditrici, giovani professionisti, start-up e imprese che desiderano andare oltre i confini tradizionali di categoria. Partecipare significa essere protagonisti di una rete che sostiene formazione mirata, innovazione e advocacy.",
  "Associazioni Territoriali": "Le Associazioni Territoriali rappresentano un punto di riferimento concreto per le imprese operanti in diverse aree della città e della provincia di Roma, supportandole con servizi, informazioni e opportunità di confronto.",
};

/* ── Colori badge tipologia ─────────────────────────────────────── */
export const BADGE_COLORS = {
  "Associazioni e Federazioni di Categoria": "bg-blue-100 text-blue-700",
  "Associazioni Aderenti": "bg-emerald-100 text-emerald-700",
  "Gruppi trasversali": "bg-purple-100 text-purple-700",
  "Associazioni Territoriali": "bg-amber-100 text-amber-700",
};

/* ── Colori hex per mercato (per effetti trasparenza inline) ────────── */
export const MERCATO_HEX = {
  "Ristorazione e Turismo": "#f97316", // orange-500
  "Immobiliare":            "#0d9488", // teal-600
  "Commercio":              "#4f46e5", // indigo-600
  "Servizi e ICT":          "#0284c7", // sky-600
  "Alimentare":             "#16a34a", // green-600
  "Professioni":            "#f59e0b", // amber-500
  "Sanità":                 "#e11d48", // rose-600
  "Mobilità":               "#475569", // slate-600
};
export const MERCATO_COLORS = {
  "Ristorazione e Turismo": { chip: "bg-orange-50 text-orange-700 border-orange-200 hover:bg-orange-100", active: "bg-orange-500 text-white border-orange-500", badge: "bg-orange-100 text-orange-700" },
  "Immobiliare":            { chip: "bg-teal-50 text-teal-700 border-teal-200 hover:bg-teal-100",         active: "bg-teal-600 text-white border-teal-600",   badge: "bg-teal-100 text-teal-700" },
  "Commercio":              { chip: "bg-indigo-50 text-indigo-700 border-indigo-200 hover:bg-indigo-100", active: "bg-indigo-600 text-white border-indigo-600", badge: "bg-indigo-100 text-indigo-700" },
  "Servizi e ICT":          { chip: "bg-sky-50 text-sky-700 border-sky-200 hover:bg-sky-100",             active: "bg-sky-600 text-white border-sky-600",     badge: "bg-sky-100 text-sky-700" },
  "Alimentare":             { chip: "bg-green-50 text-green-700 border-green-200 hover:bg-green-100",     active: "bg-green-600 text-white border-green-600", badge: "bg-green-100 text-green-700" },
  "Professioni":            { chip: "bg-amber-50 text-amber-700 border-amber-200 hover:bg-amber-100",     active: "bg-amber-500 text-white border-amber-500", badge: "bg-amber-100 text-amber-700" },
  "Sanità":                 { chip: "bg-rose-50 text-rose-700 border-rose-200 hover:bg-rose-100",         active: "bg-rose-600 text-white border-rose-600",   badge: "bg-rose-100 text-rose-700" },
  "Mobilità":               { chip: "bg-slate-100 text-slate-600 border-slate-300 hover:bg-slate-200",   active: "bg-slate-600 text-white border-slate-600", badge: "bg-slate-100 text-slate-600" },
};
